module.exports = __webpack_public_path__ + "assets/img/11_650_big.66e5f472.jpg";